<script setup lang="ts">
import Label from '~/ui/Label.vue'

defineProps<{
  disabled?: boolean
  label?: string
}>()
const expiresAt = defineModel<string | null>({ required: true })
</script>

<template>
  <Label :label>
    <div
      class="color-default-solid shape-field layout-row"
      ui-raised
      ui-block-size="48"
    >
      <input
        type="datetime-local"
        class="font-caption"
        :style="{ outline: 'none', cursor: 'text', border: 'none' }"
        :value="expiresAt
          ? new Date(new Date(expiresAt).getTime() - new Date(expiresAt).getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16)
          : ''
        "
        :disabled
        @change="(e: Event) => {
          const val = (e.target as HTMLInputElement).value
          expiresAt = val ? new Date(val).toISOString() : null
        }"
      >
    </div>
    <div
      style="position: absolute; top: 100%; line-height: 1em; margin-left: 16px;"
      class="font-caption"
    >
      <slot />
    </div>
  </Label>
</template>
